module.exports = "/img/sample-caterpillar-02.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/sample-caterpillar-02.png
// module id = 453
// module chunks = 0